import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: "OuterLogin",
        path: "/outer-login",
        component: () => import("./components/HomeLogin.vue"),
        meta: { guest: true }
    }
];

export default routes;
